module.exports = __webpack_public_path__ + "media/src/images/abouts/items/delivery/maruho-78f687c80d1e343929a309ca24cd9a19.jpg";